let isBackendAvailable = true;

export const getBackendAvailability = () => isBackendAvailable;

export const setBackendAvailability = (value: boolean) => {
  isBackendAvailable = value;
};
